import { FormControl, MenuItem } from '@mui/material';
import { FC, useState } from 'react';
import { WhiteBorderSMBSelect } from '../../../../helpers/styles';
type IClosingCalendarStepsDropdown = {
  steps: number[];
  selectedStep: number;
  setStep: (step: number) => void;
};
export const ClosingCalendarStepsDropdown: FC<IClosingCalendarStepsDropdown> = ({
  steps,
  selectedStep,
  setStep
}) => {
  const [displayStep, setDisplayStep] = useState(selectedStep);
  const formatDisplayValue = (step: number) => {
    switch (step) {
      case 15:
        return '15 Minutes';
      case 30:
        return '30 Minutes';
      case 60:
        return '1 Hour';
      default:
        return 'No Step';
    }
  };
  return (
    <FormControl fullWidth variant="outlined" size="small">
      <WhiteBorderSMBSelect
        name={'Steps'}
        label={'Time Interval'}
        value={displayStep}
        onChange={({ target: { value } }) => {
          setDisplayStep(+value);
          setStep(+value);
        }}
        SelectProps={{
          MenuProps: {
            sx: {
              maxHeight: '30rem'
            }
          }
        }}
      >
        {steps?.map((step, index) => {
          return (
            <MenuItem key={`${step}-step-dropdown`} value={`${step}`}>
              {formatDisplayValue(step)}
            </MenuItem>
          );
        })}
      </WhiteBorderSMBSelect>
    </FormControl>
  );
};
